import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

const AccessibilityStatement = () => {
  return (
    <div className="min-h-screen bg-[#faf7f2]" dir="rtl">
      <Navbar />

      <main id="main-content" tabIndex={-1}>
        {/* Hero */}
        <section className="pt-32 pb-12 bg-[#1a0a00]" aria-labelledby="accessibility-title">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <span
              className="inline-block bg-[#e85d04]/20 text-[#f4a261] border border-[#e85d04]/30 px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
              style={{ fontFamily: "'Assistant', sans-serif" }}
              aria-hidden="true"
            >
              <i className="ri-eye-line ml-1" aria-hidden="true"></i>
              נגישות
            </span>
            <h1
              id="accessibility-title"
              className="text-white font-black text-4xl md:text-5xl mb-4"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              הצהרת נגישות
            </h1>
            <p
              className="text-white/70 text-lg max-w-2xl mx-auto"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              Meet n&apos; Meat מחויבת לנגישות דיגיטלית לכלל המשתמשים
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-6">
            <article className="bg-white rounded-2xl p-8 md:p-12 border border-[#f0e0d0]">

              <p
                className="text-[#3d2010] text-base leading-relaxed mb-8"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                אנו רואים חשיבות עליונה במתן שירות שוויוני ונגיש לכלל הלקוחות, לרבות אנשים עם מוגבלויות. אתר זה עבר תהליך הנגשה קפדני בהתאם להוראות חוק שוויון זכויות לאנשים עם מוגבלות ותקנות נגישות השירות.
              </p>

              <section aria-labelledby="level-heading" className="mb-8">
                <h2
                  id="level-heading"
                  className="text-[#1a0a00] font-black text-2xl mb-4"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  רמת הנגישות
                </h2>
                <p
                  className="text-[#3d2010] text-base leading-relaxed"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  האתר מותאם לדרישות התקן הישראלי 5568 קווים מנחים לנגישות תכנים באינטרנט ברמת AA. האתר נבדק ונמצא תואם לדפדפנים הנפוצים ומותאם לשימוש בטכנולוגיות מסייעות כגון תוכנות הקראת מסך.
                </p>
              </section>

              <section aria-labelledby="actions-heading" className="mb-8">
                <h2
                  id="actions-heading"
                  className="text-[#1a0a00] font-black text-2xl mb-4"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  פעולות הנגשה שבוצעו באתר
                </h2>
                <ul
                  className="list-none p-0 m-0 flex flex-col gap-3"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  {[
                    "התאמה מלאה לניווט יעיל באמצעות מקלדת.",
                    "התאמת ניגודיות הצבעים לקריאה נוחה וברורה.",
                    "הוספת טקסט חלופי לתמונות ולרכיבים גרפיים קיימים.",
                    "סידור מבנה כותרות תקין והיררכי המאפשר התמצאות קלה בתוכן.",
                    "התאמות בקוד לתמיכה מלאה בקוראי מסך.",
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <div
                        className="w-6 h-6 flex items-center justify-center bg-[#e85d04]/15 rounded-full flex-shrink-0 mt-0.5"
                        aria-hidden="true"
                      >
                        <i className="ri-check-line text-[#e85d04] text-sm" aria-hidden="true"></i>
                      </div>
                      <span className="text-[#3d2010] text-base leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
              </section>

              <section aria-labelledby="contact-heading" className="mb-0">
                <h2
                  id="contact-heading"
                  className="text-[#1a0a00] font-black text-2xl mb-4"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  דרכי התקשרות ובקשות התאמה
                </h2>
                <p
                  className="text-[#3d2010] text-base leading-relaxed mb-6"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  אנו ממשיכים במאמצים לשמור על נגישות האתר כחלק ממחויבותנו לאפשר לכלל האוכלוסייה להשתמש בו באופן עצמאי. במידה ונתקלתם בקושי לגלוש באתר או אם יש לכם הערות בנושא הנגישות, נשמח לעמוד לרשותכם ולסייע.
                </p>
                <div
                  className="bg-[#faf7f2] rounded-xl p-6 border border-[#f0e0d0]"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  <p className="text-[#1a0a00] font-bold text-base mb-1">אנא צרו קשר עם רכזת הנגישות שלנו:</p>
                  <address className="not-italic flex flex-col gap-2 mt-3">
                    <p className="text-[#3d2010] text-base">
                      <strong>שם רכזת הנגישות:</strong> איילת
                    </p>
                    <p className="text-[#3d2010] text-base">
                      <strong>דואר אלקטרוני:</strong>{" "}
                      <a
                        href="mailto:Lior.job@gmail.com"
                        className="text-[#e85d04] hover:underline"
                        aria-label="שלחו מייל לרכזת הנגישות"
                      >
                        Lior.job@gmail.com
                      </a>
                    </p>
                    <p className="text-[#3d2010] text-base">
                      <strong>טלפון ליצירת קשר:</strong>{" "}
                      <a
                        href="tel:+972542465614"
                        className="text-[#e85d04] hover:underline"
                        aria-label="התקשרו לרכזת הנגישות"
                      >
                        054-246-5614
                      </a>
                    </p>
                  </address>
                </div>
              </section>

            </article>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AccessibilityStatement;
